import { UserCreation } from "../components/RegisterInterface"
import { build_url } from "./Api"
import { fetchJson, RequestInitGet, RequestInitPost } from "./request"

class RegisterService {
    async register(data: UserCreation): Promise<any> {
        return await fetchJson(build_url("users"), RequestInitPost(data))
    }

    async validate(token: string | undefined): Promise<any> {
        return await fetchJson(build_url(`users/validate?email_token=${token}`), RequestInitGet)
    }
}

export default RegisterService
